<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Google Meet" class="d-icon d-icon--google-meet" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 8.5v7L4 16l2.5-.5v-7L4 8l-2.5.5Z" fill="#1E88E5"/><path d="M18.5 12v7a1.5 1.5 0 0 1-1.5 1.5H6.5L6 18l.5-2.5h7V12l2.5-.5 2.5.5Z" fill="#4CAF50"/><path d="M18.5 5v7h-5V8.5h-7L6 6l.5-2.5H17A1.5 1.5 0 0 1 18.5 5Z" fill="#FBC02D"/><path d="M6.5 15.5v5H3A1.5 1.5 0 0 1 1.5 19v-3.5h5Z" fill="#1565C0"/><path d="M6.5 3.5v5h-5l5-5Z" fill="#E53935"/><path d="m19 12-.5 4.225-5-4.225 5-4.225L19 12Z" fill="#2E7D32"/><path d="M23 5.055v13.89c0 .42-.49.655-.815.39l-3.685-3.11v-8.45l3.685-3.11a.501.501 0 0 1 .815.39Z" fill="#4CAF50"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconGoogleMeet',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
